import { TreeGrid, ColumnMenu as TreeGridColumnMenu } from '@syncfusion/ej2-treegrid';
/**
 * Configures columnMenu collection in Gantt.
 *
 * @hidden
 */
export class ColumnMenu {
    constructor(parent) {
        TreeGrid.Inject(TreeGridColumnMenu);
        this.parent = parent;
    }
    /**
     * @returns {HTMLAllCollection} .
     * To get column menu collection.
     */
    getColumnMenu() {
        return this.parent.treeGrid.columnMenuModule.getColumnMenu();
    }
    destroy() {
        // column menu destroy module
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} .
     * @private
     */
    getModuleName() {
        return 'columnMenu';
    }
}
